import { authenticatedFetch } from './base'

/**
 * Get a list of countries stored in the system in specified language
 *
 * @param {number} languageId - language ID
 * @returns {*} - response containing a list of countries
 */
export const fetchCountries = (languageId) => {
	
	let url = `/api/country`;

	if(languageId)
	{
		url += `/${languageId}`;
	}

	return authenticatedFetch(url, { method: 'get' })
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(user) {
			return user
		})
}

/**
 * Get a list of countries stored in the system in specified language
 *
 * @param {string} locale - locale name
 * @returns {*} - response containing a list of countries
 */
export const fetchCountriesByLocale = (locale) => {
	
	let url = `/api/country/locale/${locale}`;

	return authenticatedFetch(url, { method: 'get' })
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(user) {
			return user
		})
}
